import { Box, FormControlLabel, Paper, Typography, useTheme } from "@mui/material";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import Radio from "@mui/material/Radio";
import { pageStyles } from "../../Styles/pageStyles";


const WalletDesign = ({Balance}) => {
    const theme = useTheme();
    const classes = pageStyles(theme);
    
    return (
        <Paper variant="outlined" sx={{ p: 1, mt: 1 }}>
            <Box sx={{ ...classes.paymentDiv, px: 2, py: 1.5 }}>
                <Box sx={classes.flex_center_btn}>
                    <Box sx={classes.flex_c}>
                        <AccountBalanceWalletIcon />
                        <Typography sx={{ fontWeight: 700 }}>Wallet</Typography>
                    </Box>
                    <Typography>Bal: {Balance}</Typography>
                </Box>
            </Box>

            <FormControlLabel
                sx={{ ...classes.paymentDiv, mt: 1 }}
                control={<Radio checked={true} />}
                disabled={false}
                label={<Typography sx={{ fontWeight: 700 }}>PayStack</Typography>}
            />
        </Paper>
    )
}

export default WalletDesign